import { DateInterval } from 'helpers/FetchDeltaData';

export const MAX_POINTS = 1440; // for 12h

const TWELVE_HOURS_IN_SECONDS = 12 * 3600;

export const getMaxPointsFromInterval = (
  interval: DateInterval,
  secondsBetweenTwoPoints?: number,
): number => {
  const intervalInSeconds = (+new Date(interval.end) - +new Date(interval.start)) / 1000;

  if (secondsBetweenTwoPoints !== undefined) {
    return intervalInSeconds / secondsBetweenTwoPoints;
  }

  return (MAX_POINTS * intervalInSeconds) / TWELVE_HOURS_IN_SECONDS;
};

export const STUCK_BITDEP_VS_RISK_MAX_POINTS = 10080; // 1 point per minutes for 7 days
export const KICK_BITDEP_VS_RISK_MAX_POINTS = 1008; // 1 point per 10 minutes for 7 days

export enum NAV_ACTIONS {
  ZOOM = 'ZOOM',
  PAN = 'PAN',
}
